<div class="web">
    <div class="fotografiaContainer">
        <div class="fotografiaCenter">
            <div id="pf-1" class="container-fluid p-0" style="margin-top: 0px;">
                <div class="row p-0">
                    <div class="col-sm-12 p-0">
                        <p style="padding-top:10px;margin-top:36px;margin-bottom: 0;">
                            <span class="tituloPanelFoto tituloBordePanelFoto">Hemeroteca</span>
                        </p>
                        <p style="margin-top: 32px;margin-bottom: 36px;">
                            <span class="subTituloFotografia">
                                <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed facere sit.0<br/> Labore architecto eligendi omnis quas eius! -->
                            </span>
                        </p>
                    </div>
                </div>
                <div id="pf-2" class="row p-0 m-0">
                    <div id="pf-3" class="col-sm-12 p-0 mt-1">
                        <div id="pf-4" class="container-fluid p-0 m-0" style="box-sizing: border-box;">
                            <div id="pf-5" class="row p-0 m-0" style="box-sizing: border-box;">
                                <div class="contenedor-galeria">
                                    <div class="columna-galeria" *ngFor="let columna of columnas">
                                      <div class="item-galeria" *ngFor="let item of columna">
                                        <div class="panelFotografiaWeb">
                                            <div class="col-sm-6 p-0" style="margin-top: 0;">
                                                <img
                                                  class="img-fluid"
                                                  [src]="getProtectedImageUrl(item.activoId)"
                                                  width="100%"
                                                  style="padding: 0; margin-top: 5px"
                                                  alt="{{ item.title }} - Imagen Protegida"
                                                  (load)="loadProtectedThumbnail(item.activoId)"
                                                />
                                            </div>
                                            <div class="col-sm-6 text-left" style="padding: 0 0 0 10px;">
                                                <p class="tituloFoto">{{item.title}}</p>
                                                <p class="subtituloFoto">{{item.subtitle}}</p>
                                                <p class="precioFoto">S/ {{item.price}}</p>
                                                <p class="descripcionFoto">{{item.description}}</p>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin:0;padding:0;">
                    <div class="col-sm-12" style="margin:0;padding:0;">
                        <p style="margin:0px;padding:0;margin-top:39px; margin-bottom:46px;">
                            <span class="verMasFotografia verMasBordeFotografia"
                                (click)="buscarConsulta('3','')">
                                VER MÁS
                            </span>                            
                        </p>
                    </div>
                </div>
                <!--div class="col-sm-12 mt-4 mb-5">
                    <div style="width: 100%; height: 1px; background-color: #a5a5a5;"></div>
                </div-->

            </div>
        </div>
    </div>
</div>
<div class="movil">
    <div class="fotografiaContainerM">
        <div class="fotografiaCenterM">
            <div id="pfm-1" class="container-fluid p-0 m-0" style="margin-top: 0px;">
                <div class="row p-0">
                    <div class="col-12 p-0">
                        <p style="padding-top:10px;margin-top:10px;margin-bottom: 0;">
                            <span class="tituloPanelFotoM tituloBordePanelFotoM">Hemeroteca</span>
                        </p>
                        <p style="margin:8px;">
                            <span class="subTituloFotografiaM">
                                <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed facere sit.1<br/> Labore architecto eligendi omnis quas eius! -->
                            </span>
                        </p>
                    </div>
                </div>
                <div id="pfm-2" class="row p-0 m-0 w-100">
                    <div id="pfm-3" class="col-12 p-0 mt-1">
                        <div id="pfm-4" class="container-fluid p-0 m-0" style="box-sizing: border-box;">
                            <div id="pfm-5" class="row p-0 m-0 w-100" style="box-sizing: border-box;">
                                <div id="pfm-6" class="col-12 p-0" *ngFor="let item of listHemeroteca.response.list">
                                    <div id="pfm-7" class="container-fluid p-0">
                                            <div id="pfm-8" class="row p-0 m-1">
                                                <div class="panelFotografiaMovil">
                                                    <div class="col-6 p-0" style="margin-top: 0;">
                                                        <img
                                                          class="img-fluid"
                                                          [src]="getProtectedImageUrl(item.activoId)"
                                                          width="100%"
                                                          style="padding: 0; margin-top: 5px"
                                                          alt="{{ item.title }} - Imagen Protegida"
                                                          (load)="loadProtectedThumbnail(item.activoId)"
                                                        />
                                                    </div>
                                                    <div class="col-6 text-left" style="padding: 0 0 0 10px;">
                                                        <p class="tituloFoto">{{item.title}}</p>
                                                        <p class="descripcionFoto">{{item.subtitle}}</p>
                                                        <p class="precioFoto">S/ {{item.price}}</p>
                                                        <p class="descripcionFoto">{{item.description}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-bottom: 20px;"> <!--margin-bottom: 20px;-->
                    <div class="col-sm-12" style="padding: 0;">
                        <p style="margin:0px;padding:0;margin-top:39px; margin-bottom:46px;">
                            <p style="margin-top: 8px;margin-bottom: 0;">
                            <span class="verMasFotografia verMasBordeFotografia"
                                (click)="buscarConsulta('3','')">
                                VER MÁS
                            </span>                            
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
